export default class ErrorHandler {
  static handle(error: any) {
    //TODO implement error handling
    console.error(error);
  }
}
